import { Expression } from "./base/Expression.ts";
import type { FilterExpression, PropertyInfo } from "./base/types.ts";

export class NotExpression extends Expression {
    readonly type = "not";
    readonly inner: FilterExpression;

    constructor(inner: FilterExpression) {
        super();
        this.inner = inner;
    }

    stringify(): string {
        return `not ${this.inner.stringify()}`;
    }

    getKey(): string {
        return `not::${this.inner.getKey()}`;
    }

    getPropertyInfo(): PropertyInfo {
        if (this.inner.type !== "function") {
            throw new Error("NotExpression: inner is not a FunctionExpression");
        }
        return this.inner.property.getPropertyInfo();
    }
}
